function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Typography from '../typography';
import { LinkAnchor, StyledLinkComponentChild, StyledLinkText } from './style';

class Link extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "handleClick", event => {
      var {
        onClick
      } = this.props;

      if (onClick) {
        onClick(event);
      }
    });

    _defineProperty(this, "renderChildren", typographyAndSpaceProps => {
      var {
        backgroundColorType,
        disabled,
        children
      } = this.props;

      var {
        type,
        textAlign
      } = typographyAndSpaceProps,
          spaceProps = _objectWithoutProperties(typographyAndSpaceProps, ["type", "textAlign"]);

      if (typeof children === 'string') {
        return /*#__PURE__*/React.createElement(StyledLinkText, _extends({}, spaceProps, {
          disabled: disabled,
          backgroundColorType: backgroundColorType
        }), /*#__PURE__*/React.createElement(Typography, _extends({
          as: 'span'
        }, typographyAndSpaceProps), this.props.children));
      } else {
        return /*#__PURE__*/React.createElement(StyledLinkComponentChild, spaceProps, children);
      }
    });
  }

  render() {
    var _this$props = this.props,
        {
      href,
      target,
      className,
      disabled
    } = _this$props,
        typographyAndSpaceProps = _objectWithoutProperties(_this$props, ["href", "target", "className", "disabled"]);

    var finalHref = disabled ? undefined : href;
    return /*#__PURE__*/React.createElement(LinkAnchor, {
      href: finalHref,
      target: target,
      onClick: this.handleClick,
      className: className
    }, this.renderChildren(typographyAndSpaceProps));
  }

}

_defineProperty(Link, "defaultProps", {
  href: '#',
  backgroundColorType: 'light',
  target: '_blank',
  type: 'body4'
});

export default Link;